import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\CompaniesImportsController::index
* @see [unknown]:0
* @route '/companies/{company}/imports'
*/
export const index = (args: { company: string | number } | [company: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/companies/{company}/imports',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CompaniesImportsController::index
* @see [unknown]:0
* @route '/companies/{company}/imports'
*/
index.url = (args: { company: string | number } | [company: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: args.company,
    }

    return index.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CompaniesImportsController::index
* @see [unknown]:0
* @route '/companies/{company}/imports'
*/
index.get = (args: { company: string | number } | [company: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CompaniesImportsController::index
* @see [unknown]:0
* @route '/companies/{company}/imports'
*/
index.head = (args: { company: string | number } | [company: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\CompaniesImportsController::create
* @see [unknown]:0
* @route '/companies/{company}/imports/create'
*/
export const create = (args: { company: string | number } | [company: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: create.url(args, options),
    method: 'post',
})

create.definition = {
    methods: ["post"],
    url: '/companies/{company}/imports/create',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CompaniesImportsController::create
* @see [unknown]:0
* @route '/companies/{company}/imports/create'
*/
create.url = (args: { company: string | number } | [company: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: args.company,
    }

    return create.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CompaniesImportsController::create
* @see [unknown]:0
* @route '/companies/{company}/imports/create'
*/
create.post = (args: { company: string | number } | [company: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: create.url(args, options),
    method: 'post',
})

const imports = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
}

export default imports